import { login, logout } from '@/api/user'
import { getToken, setToken, removeToken,getName,setName,removeName,getUserId,setUserId,removeUserId,
  getOrganId,setOrganId,removeOrganId,getRole,setRole, removeRole } from '@/utils/auth' 
import router, { resetRouter } from '@/router'

const state = {
  token: getToken(),
  name: getName(),
  userId: getUserId(),
  organId: getOrganId(),
  role: getRole(),
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_USERID: (state, userId) => {
    state.userId = userId
  },
  SET_ORGANID: (state, organId) => {
    state.organId = organId
  },
  SET_ROLE: (state, role) => {
    state.role = role
  },
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { code,corpId } = userInfo
    return new Promise((resolve, reject) => {
      login({ code: code.trim(),corpId:corpId }).then(response => {
        var data = response.data
         
        //截取-
        var splData = data.split('~')
        var token = splData[0]
        var name = splData[1]=='null'?'': splData[1]
        var userId = splData[2]=='null'?'': splData[2]
        var role = splData[3]=='null'?'': splData[3]
        commit('SET_TOKEN', token)
        commit('SET_NAME', name)
        commit('SET_USERID', userId)
        commit('SET_ROLE', role)
        commit('SET_ORGANID', '123456')//默认
        setToken(token)
        setName(name)
        setUserId(userId)
        setRole(role)
        resolve()
      }).catch(error => {
        console.error(error)
        reject(error)
      })
    })
  },
  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout({wecomBreedToken:state.token}).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_NAME', '')
        commit('SET_USERID', '')
        commit('SET_ORGANID', '')
        commit('SET_ROLE', '')
        removeToken()
        removeName()
        removeUserId()
        removeRole()
        resetRouter()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
